import { mapActions, mapState } from 'vuex';
import pendingRequest from '@/components/wallet/pending-requests/pending-request/pending-request.vue';
import contentLoaderMixin from '@/mixins/contentLoader';

export default {
  mixins: [
    contentLoaderMixin,
  ],
  components: {
    pendingRequest,
  },
  created() {
    this.getPendingDeposits().then(() => {
      this.isComponentReady = true;
    });
  },
  computed: {
    ...mapState('wallet', ['pendingDepositsRequests']),
  },
  methods: {
    ...mapActions('wallet', ['getPendingDeposits']),
    onSuccess() {
      this.getPendingDeposits();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-requests-deposits.js